<template>
  <div class="ctrl-notifications-notification-list">
    <el-row>
      <el-col>
        <el-button @click="$router.push('/ctrl/notification-detail/0')" type="primary">新規作成</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <div class="pagination-container">
          <el-pagination :page-size="pageSize" :pager-count="pagerCount" :total="totalCount"
            :current-page.sync="currentPage" layout="prev, pager, next" />
          <div>全 {{ totalCount }}件</div>
        </div>
        <el-table :data="list" v-loading="loading">
          <el-table-column prop="id" label="ID" width="60px">
          </el-table-column>
          <el-table-column prop="sendDatetime" label="送信日時" width="180px">
          </el-table-column>
          <el-table-column prop="sendCount" label="送信数" width="100px">
          </el-table-column>
          <el-table-column prop="title" label="件名">
          </el-table-column>
          <el-table-column width="100px">
            <template slot-scope="scope">
              <el-button @click="copy(scope.row.id)" type="success">コピー</el-button>
            </template>
          </el-table-column>
          <el-table-column width="100px">
            <template slot-scope="scope">
              <el-button @click="$router.push(`/ctrl/notification-detail/${scope.row.id}`)">詳細</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :page-size="pageSize" :pager-count="pagerCount" :total="totalCount"
          :current-page.sync="currentPage" layout="prev, pager, next" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "NotificationList",
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      pageSize: 10,
      // pageSize: 100,
      pagerCount: 7,
      currentPage: 1,
      totalCount: 0,

      // 
      list: [],
    };
  },
  computed: {
    ...mapGetters(['rt', 'apiErrorMessage']),
  },
  watch: {
    currentPage: {
      handler(newValue) {
        //
        this.getList(newValue);
      },
      immediate: true,
    },
  },
  methods: {
    getList(currentPage) {
      this.loading = true;

      //
      let parameters = "";
      parameters += `?page_size=${this.pageSize}`;
      parameters += `&current_page=${currentPage}`;
      this.$axios
        .get(`${this.rt}/l/api/notification/get-list${parameters}`)
        .then((response) => {
          console.log(response);
          if (response.data.status === 200) {
            this.list = response.data.list;
            this.totalCount = response.data.totalCount;
          } else if (response.data.status === 400) {
            alert(response.data.message);
          } else if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push("/login");
          } else {
            alert(this.apiErrorMessage);
          }
          return;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    copy(id) {
      this.$router.push(`/ctrl/notification-detail/0?copy_notification_id=${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
